export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 130,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_platformCode') || '平台',
    field: 'platformName',
    align: 'center',
    width: 160,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_platformAccountCode') || '账户',
    field: 'accountName',
    align: 'center',
    minWidth: 160,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_expandParam') || '附加参数',
    field: 'expandParam',
    align: 'center',
    width: 240,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_IsDefault') || '是否默认',
    field: 'isDefaultText',
    minWidth: 100,
    align: 'left',
    headerAlign: 'center',
    slots: { default: 'displayIsDefault' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_condition') || '使用条件',
    field: 'condition',
    minWidth: 180,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
  },
]
